export default __webpack_public_path__ + "static/media/save.8036593a.svg";